// extracted by mini-css-extract-plugin
module.exports = {"stepper":"Stepper_stepper__FlQaE","value":"Stepper_value__jJG4a","small":"Stepper_small___bGvo","button":"Stepper_button__dIjXs","deleting":"Stepper_deleting__bSgcH"};